import axios, { AxiosInstance } from 'axios'
import { ROUTES } from '@/constants'
import { deleteCookie } from 'cookies-next'

// eslint-disable-next-line import/no-anonymous-default-export
export const axiosPrivateHelper = (ctx?: any) => {
  let axiosHelper: AxiosInstance

  if (typeof window === 'undefined' && ctx) {
    axiosHelper = axios.create({
      baseURL: process.env.NEXT_PUBLIC_BASE_URL,
      headers: {
        Cookie: decodeURIComponent(ctx.req.headers.cookie),
      },
    })
  } else {
    axiosHelper = axios.create({
      baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    })
  }

  axiosHelper.interceptors.response.use(
    (res) => {
      return res
    },
    (error: any) => {
      const status = error?.response?.status
      const isServer = typeof window === 'undefined'
      if (status === 401) {
        if (isServer) {
          return Promise.reject(error)
        } else {
          localStorage.clear()
          deleteCookie('session')
          return (window.location.href = ROUTES.AUTH.SIGN_IN)
        }
      }
      if (status === 403) {
        if (isServer) {
          return Promise.reject(error)
        } else {
          localStorage.clear()
          deleteCookie('session')
          return (window.location.href = ROUTES.AUTH.SIGN_IN)
        }
      }

      return Promise.reject(error)
    }
  )
  return axiosHelper
}
